<template>
  <modal-component
    label="Términos y Condiciones"
    button-label="Cerrar"
    @close="onClose"
    @aceptar="onClose"
    :show="show"
    :terms="true"
  >
    <div class="iframe-container">
      <iframe
        title="Términos y Condiciones"
        :src="terms"
        class="no-border"
      ></iframe>
    </div>
  </modal-component>
</template>

<script>
import ModalComponent from "@/components/core/ModalComponent";
export default {
  name: "TermsConditions",
  components: {
    "modal-component": ModalComponent
  },
  props: {
    show: { type: Boolean, default: false }
  },
  methods: {
    onClose() {
      this.$emit("close");
    }
  },
  data() {
    return {
      terms: require(`@/assets/pdf/${_BBVA_MOTOR}/terms.pdf`)
    };
  }
};
</script>

<style scoped>
div.text {
  white-space: normal;
}

.iframe-container {
  height: 0;
  position: relative;
  padding-bottom: 557.14286%;
  padding-bottom: calc(557.14286% + 40px);
}

iframe {
  position: absolute;
  left: 0;
  top: 0;
  border: 0;
  width: 100%;
  height: 100%;
}

.no-border {
  border: none;
}
</style>
